import styled from "@emotion/styled";

// increasing the specificity of the styles because of AEM changes
// to be removed once the migration out of AEM is completed
export const H2 = styled(styled.h2``)`
  &&& {
    color: black;
    font-size: 20px;
    text-transform: none;
  }
`;

export const P = styled.p`
  font-size: 14px;
  text-align: ${(props) => (props.textAlign ? props.textAlign : "left")};
  @media screen and (max-width: 768px) {
    text-align: left;
  }
`;

export const LabelContainer = styled.div`
  width: 25%;
  padding: 15px 0;
  border-bottom: 2px solid #eee;
  font-size: 14px;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const InputContainer = styled.div`
  width: 75%;
  padding: 15px 0;
  border-bottom: 2px solid #eee;
  font-size: 14px;
  font-weight: bold;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

// increasing the specificity of the styles because of AEM changes
// to be removed once the migration out of AEM is completed
export const H1 = styled(styled.h1``)`
  &&& {
    font-size: 26px;
    text-align: center;
    text-transform: none;
    @media screen and (max-width: 768px) {
      text-align: left;
    }
  }
`;
export const PromoContainer = styled.div`
  background-color: #f5f2f2;
  padding: 10px;
  font-size: 14px;
  margin-top: 15px;
  color: #545454;
`;

export const Strong = styled.strong`
  line-height: 1.8;
`;
